import classes from "./VideoModal.module.css";
import { Fragment, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import toastr from "toastr";

const VideoModal = (props) => {
  return (
    <Fragment>
      <div className={classes.backdrop} onClick={props.onClose}></div>
      <div className={classes.modal}>
        <div className={classes.modalHeader}>
          <span className={classes.modalHeaderText}>{props.title}</span>
          <FaTimes
            onClick={props.onClose}
            color="#9F9F9F"
            className={classes.modalHeaderButton}
            size={25}
          />
        </div>
        <div className={classes.modalContent}>
          <video
            src={props.videoPath}
            className={classes.video}
            controls
            poster="your-poster-image.jpg"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </Fragment>
  );
};

export default VideoModal;
